/* AI Assistant widget (Plane 1 shell).
 * Talks to the Plane 2 backend over the Shopify App Proxy (same-origin),
 * default POST {proxyPath}. Streams the reply via SSE.
 * Config is injected by snippets/ai-assistant.liquid as window.AI_ASSISTANT_CONFIG.
 */
(function () {
  "use strict";

  var cfg = window.AI_ASSISTANT_CONFIG || {};
  var PROXY_PATH = cfg.proxyPath || "/apps/ai/chat";
  var assistantName = cfg.assistantName || "Maria";
  var loggedIn = cfg.loggedIn === true || cfg.loggedIn === "true";
  var customer = cfg.customer || null;
  var customerFirstName = customer && customer.firstName ? String(customer.firstName).trim() : "";
  var browsingKey = "mariaBrowsingHistory";

  function showPersonalizationToast() {
    var t = document.createElement("div");
    t.className = "ai-pz-toast";
    t.setAttribute("role", "status");
    t.textContent = "✓ Your personalization has been cleared.";
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-in"); });
    setTimeout(function () {
      t.classList.remove("is-in");
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 400);
    }, 4000);
  }

  // Honor a cross-origin "clear personalization" request — e.g. from the customer-
  // account extension on hosted accounts, which can't reach this origin's storage.
  (function () {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("clearPersonalization") !== "1") return;
      try { localStorage.removeItem(browsingKey); } catch (e) {}
      try {
        sessionStorage.removeItem("mariaGuestLead");
        sessionStorage.removeItem("aiAssistantPosition");
      } catch (e) {}
      params.delete("clearPersonalization");
      var qs = params.toString();
      window.history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : "") + window.location.hash);
      showPersonalizationToast();
    } catch (e) {}
  })();

  // Order context (set by templates/customers/order.liquid). When present, fetch
  // a signed, order-scoped token so the assistant can answer about THIS order.
  var orderCtx = window.AI_ASSISTANT_ORDER || null;
  var orderToken = null;
  if (orderCtx && orderCtx.orderId) {
    var tokenPath = orderCtx.tokenPath || "/apps/ai/order-token";
    fetch(tokenPath + "?order_id=" + encodeURIComponent(orderCtx.orderId), {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.token) orderToken = j.token; })
      .catch(function () {});
    if (orderCtx.orderName) {
      cfg.greeting =
        "You're viewing order " +
        orderCtx.orderName +
        ". Ask me about its status, tracking, or starting a return.";
    }
  }

  var root = document.getElementById("ai-assistant");
  if (!root) return;

  var launcher = root.querySelector(".ai-launcher");
  var panel = root.querySelector(".ai-panel");
  var log = root.querySelector(".ai-log");
  var guest = root.querySelector(".ai-guest");
  var guestForm = root.querySelector(".ai-guest__form");
  var quickActions = root.querySelector(".ai-quick-actions");
  var form = root.querySelector(".ai-form");
  var input = root.querySelector(".ai-input");

  var history = []; // [{role:'user'|'assistant', content:string}]
  var chatSessionId = null;
  var busy = false;
  var hasDragged = false;
  var cartContext = null; // refreshed from /cart.js when the panel opens

  function updateMode() {
    if (loggedIn) {
      if (guest) guest.hidden = true;
      if (log) log.hidden = false;
      if (quickActions) quickActions.hidden = false;
      if (form) form.hidden = false;
    } else {
      if (guest) guest.hidden = false;
      if (log) log.hidden = true;
      if (quickActions) quickActions.hidden = true;
      if (form) form.hidden = true;
    }
  }

  function positionPanel(anchor) {
    if (!panel) return;
    var margin = 12;
    var gap = 12;
    var anchorRect = anchor && anchor.left !== undefined
      ? anchor
      : (anchor || launcher).getBoundingClientRect();
    var width = Math.min(360, window.innerWidth - margin * 2);
    var height = Math.min(520, window.innerHeight - margin * 2);
    var preferredLeft = anchorRect.right - width;
    var preferredTop = anchorRect.top - height - gap;

    if (preferredTop < margin) {
      preferredTop = anchorRect.bottom + gap;
    }
    if (preferredTop + height > window.innerHeight - margin) {
      preferredTop = window.innerHeight - height - margin;
    }

    var left = Math.max(margin, Math.min(window.innerWidth - width - margin, preferredLeft));
    var top = Math.max(margin, preferredTop);

    panel.style.width = width + "px";
    panel.style.height = height + "px";
    panel.style.left = left + "px";
    panel.style.top = top + "px";
    panel.style.right = "auto";
    panel.style.bottom = "auto";
  }

  // Pull the shopper's own cart (same-origin, no PII) so Maria can help complete an
  // in-progress purchase — on-site abandoned-cart recovery.
  function refreshCart() {
    if (!loggedIn) return;
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.item_count) { cartContext = null; return; }
        cartContext = {
          itemCount: c.item_count,
          total: c.total_price != null ? (c.total_price / 100).toFixed(2) : null,
          currency: c.currency || null,
          items: (c.items || []).slice(0, 6).map(function (i) {
            return { title: i.product_title || i.title, quantity: i.quantity };
          })
        };
      })
      .catch(function () {});
  }

  function open(anchor) {
    var anchorRect = anchor
      ? anchor.getBoundingClientRect()
      : launcher.getBoundingClientRect();
    panel.hidden = false;
    root.classList.add("is-open");
    launcher.setAttribute("aria-expanded", "true");
    updateMode();
    positionPanel(anchorRect);
    if (loggedIn) input.focus();
    refreshCart();
    if (loggedIn && !log.dataset.greeted && cfg.greeting) {
      addBubble("assistant", buildGreeting());
      log.dataset.greeted = "1";
    }
  }
  function close() {
    panel.hidden = true;
    root.classList.remove("is-open");
    launcher.setAttribute("aria-expanded", "false");
  }

  launcher.addEventListener("click", function () {
    if (hasDragged) {
      hasDragged = false;
      return;
    }
    root.classList.contains("is-open") ? close() : open();
  });
  var closeBtn = root.querySelector(".ai-close");
  if (closeBtn) closeBtn.addEventListener("click", close);
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-ai-assistant-open]");
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });

  window.addEventListener("resize", function () {
    if (root.classList.contains("is-open")) positionPanel();
  });

  function applySavedPosition() {
    try {
      var saved = JSON.parse(sessionStorage.getItem("aiAssistantPosition") || "null");
      if (!saved) return;
      root.style.left = saved.left + "px";
      root.style.top = saved.top + "px";
      root.style.right = "auto";
      root.style.bottom = "auto";
    } catch (_) {}
  }

  function clampPosition(left, top) {
    var rect = root.getBoundingClientRect();
    var margin = 12;
    return {
      left: Math.max(margin, Math.min(window.innerWidth - rect.width - margin, left)),
      top: Math.max(margin, Math.min(window.innerHeight - rect.height - margin, top))
    };
  }

  function savePosition(left, top) {
    try {
      sessionStorage.setItem("aiAssistantPosition", JSON.stringify({ left: left, top: top }));
    } catch (_) {}
  }

  function enableDrag() {
    if (!launcher || !window.PointerEvent) return;
    var drag = null;
    launcher.addEventListener("pointerdown", function (e) {
      if (root.classList.contains("is-open")) return;
      var rect = root.getBoundingClientRect();
      drag = {
        id: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        offsetX: e.clientX - rect.left,
        offsetY: e.clientY - rect.top,
        moved: false
      };
      launcher.setPointerCapture(e.pointerId);
    });
    launcher.addEventListener("pointermove", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = Math.abs(e.clientX - drag.startX);
      var dy = Math.abs(e.clientY - drag.startY);
      if (dx + dy < 8) return;
      drag.moved = true;
      hasDragged = true;
      root.classList.add("is-dragging");
      var pos = clampPosition(e.clientX - drag.offsetX, e.clientY - drag.offsetY);
      root.style.left = pos.left + "px";
      root.style.top = pos.top + "px";
      root.style.right = "auto";
      root.style.bottom = "auto";
    });
    launcher.addEventListener("pointerup", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var rect = root.getBoundingClientRect();
      if (drag.moved) savePosition(rect.left, rect.top);
      root.classList.remove("is-dragging");
      drag = null;
      window.setTimeout(function () { hasDragged = false; }, 0);
    });
  }

  applySavedPosition();
  enableDrag();
  rememberViewedProduct();
  restoreGuestLead();

  if (guestForm) {
    guestForm.addEventListener("submit", function () {
      saveGuestLead();
    });
  }
  if (quickActions) {
    quickActions.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-ai-prompt]");
      if (!btn || busy) return;
      var prompt = btn.getAttribute("data-ai-prompt");
      if (!prompt) return;
      input.value = prompt;
      form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    });
  }

  function buildGreeting() {
    var greeting = cfg.greeting || "";
    if (!customerFirstName) return greeting;
    return "Welcome back, " + customerFirstName + ". " + greeting;
  }

  function saveGuestLead() {
    try {
      var name = root.querySelector(".ai-guest-name");
      var email = root.querySelector(".ai-guest-email");
      sessionStorage.setItem("mariaGuestLead", JSON.stringify({
        name: name ? name.value.trim() : "",
        email: email ? email.value.trim() : ""
      }));
    } catch (_) {}
  }

  function restoreGuestLead() {
    if (loggedIn) return;
    try {
      var lead = JSON.parse(sessionStorage.getItem("mariaGuestLead") || "null");
      if (!lead) return;
      var name = root.querySelector(".ai-guest-name");
      var email = root.querySelector(".ai-guest-email");
      if (name && lead.name) name.value = lead.name;
      if (email && lead.email) email.value = lead.email;
    } catch (_) {}
  }

  function getBrowsingHistory() {
    if (!loggedIn) return [];
    try {
      var items = JSON.parse(localStorage.getItem(browsingKey) || "[]");
      return Array.isArray(items) ? items.slice(0, 6) : [];
    } catch (_) {
      return [];
    }
  }

  function rememberViewedProduct() {
    if (!loggedIn || !cfg.viewedProduct || !cfg.viewedProduct.handle) return;
    try {
      var items = getBrowsingHistory();
      var product = {
        handle: cfg.viewedProduct.handle,
        title: cfg.viewedProduct.title || "",
        url: cfg.viewedProduct.url || "",
        price: cfg.viewedProduct.price || "",
        image: cfg.viewedProduct.image || "",
        viewedAt: new Date().toISOString()
      };
      items = items.filter(function (item) { return item && item.handle !== product.handle; });
      items.unshift(product);
      localStorage.setItem(browsingKey, JSON.stringify(items.slice(0, 12)));
    } catch (_) {}
  }

  function addBubble(role, text) {
    var el = document.createElement("div");
    el.className = "ai-msg ai-msg--" + role;
    el.textContent = text;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  // Renders a horizontal strip of product cards from a "products" SSE event.
  function renderProducts(items) {
    if (!items || !items.length) return;
    var seen = {};
    var wrap = document.createElement("div");
    wrap.className = "ai-products";
    items.forEach(function (p) {
      if (!p || !p.url || seen[p.url]) return; // de-dupe across tool calls
      seen[p.url] = 1;
      var card = document.createElement("a");
      card.className = "ai-card";
      card.href = p.url;
      if (p.image) {
        var img = document.createElement("img");
        img.className = "ai-card__img";
        img.src = p.image;
        img.alt = p.title || "";
        // Eager: inside a scrolling panel, lazy images get deferred/placeholdered
        // and the cards look blank. Hide the image area if the URL fails.
        img.loading = "eager";
        img.onerror = function () { img.style.display = "none"; };
        card.appendChild(img);
      }
      var body = document.createElement("div");
      body.className = "ai-card__body";
      var t = document.createElement("span");
      t.className = "ai-card__title";
      t.textContent = p.title || "";
      body.appendChild(t);
      if (p.price) {
        var pr = document.createElement("span");
        pr.className = "ai-card__price";
        pr.textContent = p.price;
        body.appendChild(pr);
      }
      card.appendChild(body);
      wrap.appendChild(card);
    });
    if (wrap.children.length) {
      log.appendChild(wrap);
      log.scrollTop = log.scrollHeight;
    }
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!loggedIn) return;
    if (busy) return;
    var message = input.value.trim();
    if (!message) return;
    input.value = "";
    addBubble("user", message);
    history.push({ role: "user", content: message });
    send(message);
  });

  function send(message) {
    if (!loggedIn) {
      addBubble("assistant", "Please sign in to chat with " + assistantName + ".");
      return;
    }
    busy = true;
    var assistantEl = addBubble("assistant", "");
    assistantEl.classList.add("is-typing");
    var acc = "";
    var pendingProducts = []; // collected during the stream, rendered once at the end

    fetch(PROXY_PATH, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: message,
        history: history.slice(0, -1), // exclude the just-pushed user turn
        chatSessionId: chatSessionId,
        productHandle: cfg.productHandle || null,
        orderToken: orderToken,
        assistantName: assistantName,
        customerFirstName: customerFirstName || null,
        browsingHistory: getBrowsingHistory(),
        cart: cartContext
      })
    })
      .then(function (res) {
        if (!res.ok || !res.body) throw new Error("Request failed (" + res.status + ")");
        var reader = res.body.getReader();
        var decoder = new TextDecoder();
        var buffer = "";

        function pump() {
          return reader.read().then(function (chunk) {
            if (chunk.done) return finish();
            buffer += decoder.decode(chunk.value, { stream: true });
            var parts = buffer.split("\n\n");
            buffer = parts.pop();
            parts.forEach(function (part) {
              var line = part.replace(/^data: /, "").trim();
              if (!line) return;
              var evt;
              try { evt = JSON.parse(line); } catch (_) { return; }
              if (evt.type === "session") {
                chatSessionId = evt.chatSessionId;
              } else if (evt.type === "delta") {
                acc += evt.text;
                assistantEl.classList.remove("is-typing");
                assistantEl.textContent = acc;
                log.scrollTop = log.scrollHeight;
              } else if (evt.type === "products") {
                if (evt.items && evt.items.length) {
                  pendingProducts = pendingProducts.concat(evt.items);
                }
              } else if (evt.type === "error") {
                assistantEl.classList.remove("is-typing");
                assistantEl.textContent = "Sorry — something went wrong. Please try again.";
              }
            });
            return pump();
          });
        }

        function finish() {
          assistantEl.classList.remove("is-typing");
          if (acc) history.push({ role: "assistant", content: acc });
          // Render product cards last, after all text — so streaming/scroll churn
          // can't visually clobber them.
          renderProducts(pendingProducts);
          busy = false;
        }

        return pump();
      })
      .catch(function () {
        assistantEl.classList.remove("is-typing");
        assistantEl.textContent = "Sorry — I couldn't reach the assistant. Please try again.";
        busy = false;
      });
  }
})();
